import { createEffect } from 'effector';

const createPollingFx = <T, V>(params: {
    limit?: number;
    interval?: number;
    fx: (args: T) => Promise<V>;
    condition: (result: V) => boolean;
}) =>
    createEffect(async (args: T) => {
        const { limit = 30, interval = 1000, fx, condition } = params;

        let attempt = 0;
        const result = await fx(args);
        attempt++;
        while (true && attempt <= limit) {
            await new Promise((resolve) => setTimeout(resolve, interval));
            const result = await fx(args);
            attempt++;
            if (!condition(result)) {
                return result;
            }
            if (attempt > limit) {
                throw new Error('Polling limit exceeded');
            }
        }
        return result;
    });

export default createPollingFx;
